/**
 * Test IDs for QA automation.
 */
export const testIds = {
  uploadButtonOpenFilePicker: "upload-button-open-file-picker",
  uploadButtonFileSelection: "upload-button-file-selection",
} as const;
